
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as go7aNRkAPalwAHzd0G_45g7Pz9nTxgsUrr7eaNWkC5veyYMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexUwrCNdfzqTSzSc3rCutO2qtVwnbHbnA9YXLa7H5aSigMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchjb_451gQfsN_45_n5YoTuo4l8sNv9YQPr_dtzoH7_45N7P46YMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexqke1G2dNrBQNxNEhbgz8QayP2gl7O9DBTdfXj2oQa1UMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93rOoPmSPJS_6VsVvUHCzPz5jLGa7l7bQ9GJlJ_45ZWbDtsMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexJD_45bFkr85qscBnrC9GX15une1PLzSLmA48ivmHYEV7QMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93hec41QOXQ2gsN_GDv059uQ7wAQgDMbrcMF3dnORep7cMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index0_45NgTJlZmSsHpiKVyFmh_4590KpoOBNSRcKF8cJMAyNHwMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93KYgmh53ilJ6FOjbQ0InlUaeD3PZWix9tMZNTHQgaeOkMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexa9LksmTC04oTSfYROKBoC5lQgBvG6koJSVm1h1V0eyYMeta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexb_hAb5vnxb4VcU4VbdIsUC2e28Q9s3sBiHuTtNwu5W0Meta } from "/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexJD_45bFkr85qscBnrC9GX15une1PLzSLmA48ivmHYEV7QMeta || {},
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index0_45NgTJlZmSsHpiKVyFmh_4590KpoOBNSRcKF8cJMAyNHwMeta || {},
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexa9LksmTC04oTSfYROKBoC5lQgBvG6koJSVm1h1V0eyYMeta || {},
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexb_hAb5vnxb4VcU4VbdIsUC2e28Q9s3sBiHuTtNwu5W0Meta || {},
    component: () => import("/codebuild/output/src1568824401/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]